module.exports = __webpack_public_path__ + "img/header-logo4.8394b33b.png";